// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICustomPageable } from './ICustomPageable';
import {
    ICustomPageableFromJSON,
    ICustomPageableFromJSONTyped,
    ICustomPageableToJSON,
    ICustomPageableToJSONTyped,
} from './ICustomPageable';
import type { IExpenseInfoDto } from './IExpenseInfoDto';
import {
    IExpenseInfoDtoFromJSON,
    IExpenseInfoDtoFromJSONTyped,
    IExpenseInfoDtoToJSON,
    IExpenseInfoDtoToJSONTyped,
} from './IExpenseInfoDto';

/**
 * 
 * @export
 * @interface ICustomPageExpenseInfoDto
 */
export interface ICustomPageExpenseInfoDto {
    /**
     * 
     * @type {number}
     * @memberof ICustomPageExpenseInfoDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageExpenseInfoDto
     */
    size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageExpenseInfoDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageExpenseInfoDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageExpenseInfoDto
     */
    empty?: boolean;
    /**
     * 
     * @type {Array<IExpenseInfoDto>}
     * @memberof ICustomPageExpenseInfoDto
     */
    content?: Array<IExpenseInfoDto>;
    /**
     * 
     * @type {ICustomPageable}
     * @memberof ICustomPageExpenseInfoDto
     */
    pageable?: ICustomPageable;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageExpenseInfoDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageExpenseInfoDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageExpenseInfoDto
     */
    total_elements?: number;
}

/**
 * Check if a given object implements the ICustomPageExpenseInfoDto interface.
 */
export function instanceOfICustomPageExpenseInfoDto(value: object): value is ICustomPageExpenseInfoDto {
    return true;
}

export function ICustomPageExpenseInfoDtoFromJSON(json: any): ICustomPageExpenseInfoDto {
    return ICustomPageExpenseInfoDtoFromJSONTyped(json, false);
}

export function ICustomPageExpenseInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICustomPageExpenseInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'size': json['size'] == null ? undefined : json['size'],
        'last': json['last'] == null ? undefined : json['last'],
        'first': json['first'] == null ? undefined : json['first'],
        'empty': json['empty'] == null ? undefined : json['empty'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IExpenseInfoDtoFromJSON)),
        'pageable': json['pageable'] == null ? undefined : ICustomPageableFromJSON(json['pageable']),
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
    };
}

export function ICustomPageExpenseInfoDtoToJSON(json: any): ICustomPageExpenseInfoDto {
    return ICustomPageExpenseInfoDtoToJSONTyped(json, false);
}

export function ICustomPageExpenseInfoDtoToJSONTyped(value?: ICustomPageExpenseInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'last': value['last'],
        'first': value['first'],
        'empty': value['empty'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IExpenseInfoDtoToJSON)),
        'pageable': ICustomPageableToJSON(value['pageable']),
        'totalPages': value['total_pages'],
        'numberOfElements': value['number_of_elements'],
        'totalElements': value['total_elements'],
    };
}

